import {api} from "./api";

export const search = () => {
    return {
        products: {},
        cars: {
            error: '',
            cars: []
        },
        searchType: 'an',
        searchTerm: '',
        searchTd: '',
        searchVin: '',
        loading: false,
        results: false,
        carsSearch: false,
        find() {
            this.$watch('searchTerm', async (value) => {
                if (value && value.length > 3) {
                    this.searchTd = '';
                    this.results = true
                    this.loading = true
                    const result = (await api.get(`product/search/auto&search=${value}`)).json()
                    setTimeout(async () => {
                        this.loading = false
                        this.products = await result
                    }, 500)
                    return;
                }
                this.results = false
            });
            this.$watch('searchVin', async (value) => {
                if (value && value.length > 3) {
                    this.carsSearch = true
                    this.loading = true
                    const result = (await api.get(`custom/search/searchByVin&search=${value}`)).json()
                    setTimeout(async () => {
                        if (result) {
                            this.loading = false;
                            this.cars = await result
                        }
                    }, 500)
                    return;
                }
                this.carsSearch = false
            });
            this.$watch('searchTd', async (value) => {
                if (value && value.length > 3) {
                    this.searchTerm = '';
                    this.results = true
                    this.loading = true
                    const result = (await api.get(`custom/search/search&search=${value}&type=${this.searchType}`)).json()
                    setTimeout(async () => {
                        if (result) {
                            this.loading = false;
                            this.products = await result
                        }
                    }, 200)
                    return;
                }
                this.carsSearch = false
            })
        },
        jump(numberType) {
            if (this.searchTerm) {
                window.location = `\index.php?route=product/search&search=` + encodeURIComponent(this.searchTerm);
            }
            if (this.searchTd) {
                window.location = `\index.php?route=product/search&search=` + encodeURIComponent(this.searchTd) + '&echiv=' + encodeURIComponent(numberType);
            }
        }
    }
}